import { RootState } from '@reducers';

export const selectPersonalAccidentQuoteDetailsPage = (state: RootState) => state.personalAccidentQuoteDetailsPageReducer;
